/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { useSessionstorage } from 'rooks';
import { TextField, InputLabel } from 'components/elements';
import { useReactHookFormErrorMap } from 'hooks';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function SessionAccessForm({ onSubmit, children, appointmentId }) {
  const classes = useStyles();
  const { t } = useTranslation('labels');
  const [accessCode, setAccessCode] = useSessionstorage(`accessCode_${appointmentId}`, '');
  const {
    handleSubmit,
    clearErrors,
    control,
    formState: { errors },
    watch,
    setError,
    getValues,
  } = useForm({
    mode: 'onSubmit',
    defaultValues: { accessCode, appointmentId },
    reValidateMode: 'onSubmit',
  });

  const mapErrorToForm = useReactHookFormErrorMap(getValues, setError, '');

  useEffect(() => {
    const subscription = watch(() => clearErrors('apiError'));
    return () => subscription.unsubscribe();
  }, [watch]);

  const onSubmitForm = (data) => {
    onSubmit(data)
      ?.then(() => setAccessCode(data.accessCode))
      .catch((error) => mapErrorToForm(error));
  };

  // TODO: check error: Looks like you’ve entered the wrong code. Please copy and paste the code from your email and try again

  return (
    <form className={classes.form} onSubmit={handleSubmit(onSubmitForm)}>
      {children}
      <div className={classes.input}>
        <Controller
          className={classes.control}
          name="accessCode"
          control={control}
          rules={{ required: t('please_fill_in_this_field') }}
          render={({ field: { ref, ...restField }, fieldState: { error } }) => (
            <TextField error={!!error} helperText={error ? error.message : null} {...restField} label={<InputLabel text={t('access_code')} required />} />
          )}
        />
      </div>
      {errors.apiError && <div className={classes.error}>{errors.apiError.message}</div>}
      <Button type="submit" variant="contained" color="primary" className={classes.submit}>
        {t('join_session')}
      </Button>
    </form>
  );
}

SessionAccessForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  appointmentId: PropTypes.string.isRequired,
  children: PropTypes.element,
};

SessionAccessForm.defaultProps = {
  children: null,
};

export default SessionAccessForm;
